import { checkPermission } from '@/router/guards.ts'

const FuelTypeModule = () => import('./FuelTypeModule.vue')
const FuelTypeIndex = () => import('./views/FuelTypeIndex.vue')

export const fuelTypeRoute = {
  path: '/fuel-types',
  name: 'fuel-type',
  component: FuelTypeModule,
  meta: {
    title: 'Fuel Types',
    requiresAuth: true,
    keepAlive: true,
  },
  children: [
    {
      path: '',
      name: 'fuel-types-index',
      component: FuelTypeIndex,
      meta: {
        permission: 'fuel_type.view',
      },
      beforeEnter: checkPermission('fuel_type.view'),
    },
  ],
}
